// extracted by mini-css-extract-plugin
export default {"wrapper":"Um-z","response":"Vm-z","error":"Wm-z","disabled":"Xm-z","buttons":"Ym-z","feedbackQuestionSection":"Zm-z","yesNoWrapper":"_m-z"};